import React from "react";

export const StarLoader = ({ size = 60 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
    >
      <g id="sparkleloader">
        <polyline
          id="star1"
          points="28.5,1.5 26.6,5.6 22.5,7.5 26.6,9.4 28.5,13.5 30.4,9.4 34.5,7.5 30.4,5.6 "
        />
        <polyline points="13.5,6 9.8,14.2 1.5,18 9.8,21.8 13.5,30 17.2,21.8 25.5,18 17.2,14.2 " />
        <polyline
          id="star2"
          points="28.5,22.5 26.6,26.6 22.5,28.5 26.6,30.4 28.5,34.5 30.4,30.4 34.5,28.5 30.4,26.6 "
        />
      </g>

      <defs>
        <style type="text/css">{`
          #sparkleloader {
            fill: url(#paint1_linear_218_1644);
          }
          #star1, #star2 {
            animation: pulse-star 3s 6 ease-in-out alternate;
          }
          #star2 {
            animation-delay: 400ms;
          }

          @media (prefers-reduced-motion: no-preference) {
            #sparkleloader {
              fill: url(#paint0_linear_218_1644);
            }
            #star1, #star2 {
              animation-iteration-count: infinite;
            }
          }

          @keyframes pulse-star {
            0% {
              opacity: 1;
            }
            25% {
              opacity: 0;
            }
            75% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        `}</style>

        <linearGradient
          id="paint0_linear_218_1644"
          x1="18"
          y1="1.5"
          x2="18"
          y2="34.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stopColor="#7167C9">
            <animate
              attributeName="stop-color"
              values="#7167C9; #369AE8; #7167C9;"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate attributeName="offset" values=".3; 1; .3" dur="1s" repeatCount="indefinite" />
          </stop>
          <stop offset="1" stopColor="#369AE8">
            <animate
              attributeName="stop-color"
              values="#369AE8; #7167C9; #369AE8"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate attributeName="offset" values="1; .3; 1" dur="1s" repeatCount="indefinite" />
          </stop>
        </linearGradient>

        <linearGradient
          id="paint1_linear_218_1644"
          x1="18"
          y1="1.5"
          x2="18"
          y2="34.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stopColor="#7167C9">
            <animate
              attributeName="stop-color"
              values="#7167C9; #369AE8; #7167C9;"
              dur="1s"
              repeatCount="6"
            />
            <animate attributeName="offset" values=".3; 1; .3" dur="1s" repeatCount="6" />
          </stop>
          <stop offset="1" stopColor="#369AE8">
            <animate
              attributeName="stop-color"
              values="#369AE8; #7167C9; #369AE8"
              dur="1s"
              repeatCount="6"
            />
            <animate attributeName="offset" values="1; .3; 1" dur="1s" repeatCount="6" />
          </stop>
        </linearGradient>
      </defs>
    </svg>
  );
};
